import { isRequired } from '../../helpers/Form'


const lessonFields = {
  title: {
    validators: [isRequired]
  },
  content: {}
}

export default lessonFields
